/*
 * @Description: 
 * @Author: -898-
 * @Date: 2025-03-05 10:36:38
 * @LastEditTime: 2025-03-26 15:33:00
 * @LastEditors: -898-
 */
import Cookies from "js-cookie";

const TokenKey = "zc-Admin-Token";

const authKey = "zc-Admin-Auth";

const ExpiresInKey = "Admin-Expires-In";

const userTypeKey = "zc-Admin-userType";

export function getToken () {
    return Cookies.get(TokenKey);
}

export function setToken (token) {
    return Cookies.set(TokenKey, token);
}

export function getAuth () {
    return Cookies.get(authKey);
}

export function setAuth (auth) {
    return Cookies.set(authKey, auth);
}

export function removeToken () {
    return Cookies.remove(TokenKey);
}

export function removeAuth () {
    return Cookies.remove(authKey);
}

export function getExpiresIn () {
    return Cookies.get(ExpiresInKey) || -1;
}

export function setExpiresIn (time) {
    return Cookies.set(ExpiresInKey, time);
}

export function removeExpiresIn () {
    return Cookies.remove(ExpiresInKey);
}
export function setUsername (token) {
    return Cookies.set('username', token);
}
export function getUsername () {
    return Cookies.set('username');
}
export function removeUsername () {
    return Cookies.remove('username');
}
export function getUserType () {
    return Cookies.get(userTypeKey);
}

export function setUserType (type) {
    return Cookies.set(userTypeKey, type);
}